import type { PayForPlanMutation } from '@ctct/state-server-layer';

import { EventBus } from '../../helpers';

type PaymentButtonEvents = {
  payForPlanClicked: [payForPlanCall: PayForPlanMutation['mutateAsync']];
  payForPlanSuccess: [isSuccess: boolean];
  payForPlanLoading: [isLoading: boolean];
  payForPlanError: [errorMessage: string];
  showEmailPricingTiersClick: [];
};

class PaymentButtonEventBus extends EventBus<PaymentButtonEvents> {}

export const paymentButtonEventBus = new PaymentButtonEventBus();
